import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
	observer: true,
	listenEvents: [ 'scroll' ],
	preLoad: 1.2,
	attempt: 1
});
